import React, { Fragment } from 'react'

// Components Global
import ProfileAvatar from '../../../../../../components/ProfileAvatar'
import AlbumManager from '../../../../../../components/AlbumManager'
import { Tooltip } from '../../../../../../components/tooltip/Tooltip'

// Funtions Product
import { getItemImage } from '../../../../../../redux/Products/ProductsFunctions'

// Values
import { productValue } from '../../../../../../redux/Products/ProductsValues'

// Redux Actions
import { openConfirm } from '../../../../../../redux/App/AppActions'
import {
  updateProduct,
  uploadImagesProduct
} from '../../../../../../redux/Products/ProductsActions'


const ProductProfileAvaterManage = (props) => {
  let { product, business, fontSize, item } = props

  if (!product.avatarName) {
    product = productValue({product})
  }

  let images

  if (product.images && product.images.length !== 0) {
    images = product.images

  } else if (item) {
    images = getItemImage({ product, item })
  }

  const profiles = images && images.filter(img => img.album === 'profile')
  const profile = profiles && profiles[0]
  const { productsSettings } = business

  const handleDelete = (_id) => {
    props.dispatch(openConfirm(_id, {
      title: `ลบภาพนี้`,
      message: `กดปุ่ม "ลบภาพ" ถ้าคุณต้องการลบภาพนี้`,
      type: 'delete',
      icon: 'delete_forever',
      confirmLabel: 'ลบภาพ',
      cancelLabel: 'ยกเลิก',
      onConfirm: onDeleteImage(),
    }))
  }

  const onDeleteImage = () => {
    return (id) => {
      const actionParams = {
        body: {
          updateType: 'pull-image',
          updateElement: 'images',
          deleteId: id
        },
        toastMsg: `ลบภาพนี้แล้ว`,
        loadId: id,
        confirmId: id,
        props
      }

      const query = {
        authName: 'admin',
        dbNo: business.dbNo,
        businesses_id: business._id,
        products_id: product._id
      }

      props.dispatch(updateProduct(query, actionParams))
    }
  }

  return (
    <Fragment>
      { profile ?
        <div className="boxDiv-jsx">
          <ProfileAvatar
            circle={props.circle}
            images={profiles || []}
            imageSize="m"
            color={product.avatarColor}
            texts={product.avatarName}
            textSize={fontSize || '1.1rem'}
          />

          <div className="boxBtnDelete-jsx line-height-15">
            <Tooltip hiddenLine msg="ลบภาพนี้" width="70px" left="-35px" style={{ float: 'right' }}>
              <a onClick={() => handleDelete(profile._id)}  className={`btn-floating btn-xs-floating waves-light btn-delete`}>
                <i className="material-icons i-middle">delete</i>
              </a>
            </Tooltip>
          </div>

          <style jsx>{`
            .boxDiv-jsx {
              cursor: pointer;
              line-height: 0;
              position:  relative;
              width: 100%;
              height: 100%;
            }
            .boxBtnDelete-jsx {
              visibility: hidden;
              position: absolute;
              top: 0;
              right: 0;
              padding: 3px;
              z-index: 4;
            }
            .boxDiv-jsx:hover .boxBtnDelete-jsx {
              visibility: visible;
            }
          `}</style>
        </div>
      :
        <div className="width-full height-full">
          <AlbumManager
            {...props}
            id="profile"
            thumbnail="s"
            images={product.images}
            btnAdd={{ text: 'เพิ่มภาพ', icon: 'add', maxFile: 1 }}
            boxImgStyle={{
              width: '100%',
              height: '100%'
            }}
            upload={{
              album: 'profile',
              multiple: false,
              maxFile: 1,
              crop: {
                title: 'รูปโปรไฟล์',
                circle: false,
                style: { width: '100%', height: 'auto' },
                width: productsSettings.profile.width || 980,
                height: productsSettings.profile.height || 980
              }
            }}
            delete
            profile
            action={{
              update: updateProduct,
              uploadImage: uploadImagesProduct,
              useQuery: {
                authName: 'admin',
                dbNo: business.dbNo,
                businesses_id: business._id,
                products_id: product._id
              },
              params: {
                business,
                _id: product._id,
                imagePrefix: 'products'
              }
            }}
          />
        </div>
      }
    </Fragment>
  )
}

export default ProductProfileAvaterManage
